import React, { useContext, useEffect } from "react";
import {
  TableRow,
  TableCell,
  TableContainer,
  Table,
  TableBody,
} from "@material-ui/core";
import {
  IconButtonDatatable,
  TableHeader,
  SearchInput,
  DatatablesFooterServerSide,
  Loading,
} from "App/Component/ui";

import { useDatatables, useDatatablesServerSide } from "App/hooks";
import { SelectIcon } from "App/Assets";
import {
  getByFilterFA,
  RESET_STATE_FORM_FILTER_DATA,
  STYLE_FA_TFA,
} from "./helpers";
import { useState } from "react";
import { defaultToastError, isNull } from "App/utils/helpers";
import { FormContext } from "../context/FormContext";

export default function ListFixedAsset({ clickSelectHandler }) {
  const [rows, setRows] = useState([]);
  const [formFilter, setFormFilter] = useState(RESET_STATE_FORM_FILTER_DATA);
  const [loading, setLoading] = useState(false);
  const [totalData, setTotalData] = useState(0);
  const { formData } = useContext(FormContext);

  
  const classes = STYLE_FA_TFA();

  useEffect(() => {
    (async () => {
      await setNewDataFixedAsset();
    })();
  }, [formData.gudang_sumber_id]); // eslint-disable-line react-hooks/exhaustive-deps

  const setNewDataFixedAsset = async (
    pages = formFilter.halaman,
    limit = formFilter.jumlah,
    idGudang = formData.gudang_sumber_id,
  ) => {
    setLoading(true);
    if(isNull(formData.gudang_sumber_id)){
      setRows([]);
      setTotalData(0);
    }else{
      const res = await getByFilterFA(formFilter, pages, limit, idGudang);
      if (res.state) {
        setRows(res.data);
        setTotalData(res.meta.count);
      } else {
        setRows([]);
        defaultToastError(res.message);
      }
    }
    setLoading(false);
  };

  const {
    pagination,
    onNext,
    onPrevious,
    handleClickPageNumber,
    handleChangeLimit,
  } = useDatatablesServerSide({ setNewData: setNewDataFixedAsset });

  const handleSubmit = async (e) => {
    e.preventDefault();
    await setNewDataFixedAsset();
  };

  const { order, orderBy, handleRequestSort, length } = useDatatables({
    rows: rows,
    orderByDefault: "name",
    orderByRow: ["name"],
  });

  return (
    <>
    <paper>
     <div className={classes.header}>
        <div>
          <p className='fw-600 mb-1 mt-1'>DATA FIXED ASSET GUDANG SUMBER</p>
        </div>
        <div
          style={{
            display: "flex",
            gap: "0 10px",
          }}>
          <form onSubmit={(e) => handleSubmit(e)}>
            <SearchInput
              withIcon={true}
              onchange={(e) => {
                setFormFilter({
                  ...formFilter,
                  search: e.target.value,
                });
              }}
            />
          </form>
        </div>
      </div>
      <Loading show={loading} />
      <TableContainer
        className="custom-scrollbar"
        style={{
          maxHeight: "500px",
        }}
      >
        <Table
          className={classes.table}
          aria-labelledby="tableTitle"
          size={"medium"}
          aria-label="enhanced table"
        >
          <TableHeader
            order={order}
            orderBy={orderBy}
            onRequestSort={handleRequestSort}
            rowCount={length}
            headCells={headCells}
          />
          <TableBody>
            {rows.map((row, index) => {
              return (
                <TableRow
                  hover
                  tabIndex={-1}
                  key={index}
                  style={{
                    backgroundColor: index % 2 === 0 ? "transparent" : "#fff",
                  }}
                >
                  <TableCell
                    component="th"
                    scope="row"
                    padding="none"
                    align="center"
                  >
                    {index + 1}
                  </TableCell>
                  <TableCell
                    component="th"
                    scope="row"
                    padding="none"
                    align="center"
                  >
                    <IconButtonDatatable
                      color="secondary"
                      onClick={() => clickSelectHandler(row)}
                    >
                      <SelectIcon width={"14"} height={"14"} fill={"#fff"} />
                    </IconButtonDatatable>
                  </TableCell>
                  <TableCell align="left">{row?.id}</TableCell>
                  <TableCell align="left">{row?.name}</TableCell>
                  <TableCell align="left">{row?.code}</TableCell>
                  <TableCell align="left">{row?.gudang}</TableCell>
                </TableRow>
              );
            })}
            {rows.length === 0 && (
              <TableRow>
                <TableCell align="center" colSpan={headCells.length}>
                  Tidak ada data
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
      <DatatablesFooterServerSide
        totalData={totalData}
        pagination={pagination}
        handleChangeLimit={handleChangeLimit}
        onPrevious={onPrevious}
        onNext={onNext}
        currentPage={pagination.page}
        handleClickPageNumber={handleClickPageNumber}
      />
      </paper>
    </>
  );
}

const headCells = [
  {
    id: "no",
    disablePadding: false,
    label: "NO",
    align: "center",
    sort: false,
  },
  {
    id: "act",
    disablePadding: true,
    label: "ACT",
    sort: false,
    align: "left",
  },
  {
    id: "id",
    disablePadding: false,
    label: "ID",
    align: "left",
  },
  {
    id: "name",
    disablePadding: false,
    label: "NAMA",
    align: "left",
    minWidth: "150px",
  },
  {
    id: "code",
    disablePadding: false,
    label: "KODE",
    align: "left",
  },
  {
    id: "gudang",
    disablePadding: false,
    label: "GUDANG",
    align: "left",
  },
];
